import { createSlice } from '@reduxjs/toolkit';

export const callHistorySlice = createSlice({
  name: 'callHistory',
  initialState: {
    loading: true,
    callHistory: [],
    lastDialed: null, // last number this app actually dialed; survives history refreshes
    error: null,
  },
  reducers: {
    setCallHistory: (state, action) => {
      state.loading = false;
      state.callHistory = action.payload;
    },
    setLastDialed: (state, action) => {
      state.lastDialed = action.payload;
    }
  },
});

export const { setCallHistory, setLastDialed } = callHistorySlice.actions;
//Selectors
export const selectCallHistory = (state) => state.callHistory;
export const selectLastDialed = (state) => state.callHistory.lastDialed;
export default callHistorySlice.reducer;
